import type { Country } from '@/helpers/conf';
import { ANJOUAN_COUNTRIES } from '@/modules/policies/constants';

const TelegramLogo = '/networks/telegramLogo.svg';
const WhatsAppLogo = '/networks/whatsAppLogo.svg';
const InstagramLogo = '/networks/instagramLogo.svg';
export const TELEGRAM_LINK = 'https://t.me/levelup_com';
export const WHATSAPP_LINK =
  'https://whatsapp.com/channel/0029VaxnPSwDzgTE1ywV5J0s';
export const INSTAGRAM_LINK = 'https://www.instagram.com/levelupcasino/';

export const licenseAttributes = {
  otherDomain: {
    id: 'apg-df94f8da-c877-459b-8c07-ef39854426db',
    'data-apg-seal-id': 'df94f8da-c877-459b-8c07-ef39854426db',
    'data-apg-image-size': '256',
    'data-apg-image-type': 'basic-light-large',
  },
  default: {
    id: 'apg-0aa16dab-6b0e-4c30-b208-c36d01701c3d',
    'data-apg-seal-id': '0aa16dab-6b0e-4c30-b208-c36d01701c3d',
    'data-apg-image-size': '64',
    'data-apg-image-type': 'basic-small',
  },
};

export const SOCIAL_LINKS = [
  {
    icon: TelegramLogo,
    link: TELEGRAM_LINK,
    alt: 'Telegram',
    width: 40,
    height: 40,
    index: 0,
  },
  {
    icon: WhatsAppLogo,
    link: WHATSAPP_LINK,
    alt: 'WhatsApp',
    width: 40,
    height: 40,
    index: 1,
  },
  {
    icon: InstagramLogo,
    link: INSTAGRAM_LINK,
    alt: 'Instagram',
    width: 40,
    height: 40,
    index: 2,
  },
];

export const getFooterImages = () => [
  {
    src: '/footer/playResponsiblyLogo.svg',
    alt: 'responsibleGaming',
    href: 'https://levelupcasino.com/responsible-gaming',
    width: 110,
    height: 60,
  },
];

export const getPartnersImages = (isAustralia: boolean) => [
  {
    src: '/footer/slots-calendar-logo.webp',
    alt: 'LevelUp Casino Review At SlotsCalendar',
    href: 'https://www.slotscalendar.com/casinos/levelup-casino/',
    width: 130,
    index: 0,
  },
  {
    src: '/footer/MrGambleSeal.webp',
    alt: 'LevelUp Casino Review At MrGamble',
    href: 'https://mr-gamble.com/ca/online-casino/levelup-casino/',
    width: 46,
    isHidden: isAustralia,
    index: 1,
  },
  {
    src: '/footer/ask2Place.svg',
    alt: 'ask2Place',
    href: 'https://awards.askgamblers.com/winners/',
    width: 63,
    index: 2,
  },
  {
    src: '/footer/casinoOnlineApproved.svg',
    alt: 'Casino-on-line.com approved',
    href: 'https://www.casino-on-line.com/review/level-up-casino/',
    width: 115,
    index: 3,
  },
  {
    src: '/footer/askGamblersCertificate.svg',
    alt: 'Askgamblers Certificate',
    href: 'https://www.askgamblers.com/online-casinos/levelup-casino-review/',
    width: 130,
    index: 4,
  },
  {
    src: '/footer/casinosAnalyzer.webp',
    alt: 'casinosAnalyzer',
    href: 'https://casinosanalyzer.com/online-casinos/real-money',
    width: 107,
    index: 5,
  },
  {
    src: '/footer/clashOfSlots.webp',
    alt: 'clashOfSlots',
    href: 'https://clashofslots.com/casinos/levelup/',
    width: 109,
    index: 6,
  },
  {
    src: '/footer/chipyLogo.webp',
    alt: 'Chipo',
    href: 'https://chipy.com/casinos/levelup-casino-review',
    width: 86,
    index: 7,
  },
  {
    src: '/footer/gamblizard.svg',
    alt: 'gamblizard',
    href: 'https://gamblizard.de/beste-online-casinos/handy/',
    width: 130,
    index: 8,
  },
  {
    src: '/footer/slotozilla.svg',
    alt: 'slotozilla',
    href: 'https://www.slotozilla.com/',
    width: 125,
    index: 9,
  },
  {
    src: '/footer/automatenspielex.webp',
    alt: 'automatenspielex',
    href: 'https://automatenspielex.com/online-casinos/level-up',
    width: 80,
    index: 10,
  },
];

export const AWARDS_IMAGES = [
  {
    src: '/footer/awards/players-choice-medal.svg',
    alt: 'players choice',
    index: 0,
  },
  {
    src: '/footer/awards/new-casino-medal.svg',
    alt: 'new casino',
    index: 1,
  },
  {
    src: '/footer/awards/members-choice-medal.svg',
    alt: 'members choice',
    index: 2,
  },
  {
    src: '/footer/awards/online-casino-medal.svg',
    alt: 'online casino',
    index: 3,
  },
  {
    src: '/footer/awards/prime-perks-medal.svg',
    alt: 'prime perks',
    index: 4,
  },
];

export enum CustomFooterGroups {
  TOBIQUE = 'tobique',
  ANJOUAN = 'anjouan',
}

export interface ICopyrightConfigItem {
  i18nKey: string;
  links: {
    terms: string;
    responsibleGaming: string;
  };
}

export interface ICopyrightConfig {
  [configName: string]: ICopyrightConfigItem;
}

export const COPYRIGHT_CONFIG: ICopyrightConfig = {
  [CustomFooterGroups.TOBIQUE]: {
    i18nKey: 'footer.copyrightTobique',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
  [CustomFooterGroups.ANJOUAN]: {
    i18nKey: 'footer.copyrightAnjouan',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
};

export const getCopyrightConfig = (
  countryCode: Country
): ICopyrightConfigItem => {
  if (ANJOUAN_COUNTRIES.includes(countryCode)) {
    return COPYRIGHT_CONFIG[CustomFooterGroups.ANJOUAN];
  }
  return COPYRIGHT_CONFIG[CustomFooterGroups.TOBIQUE];
};
